module.exports = __webpack_public_path__ + "img/scanner-app-logo.3fbf6e26.svg";